import type { AnchorHTMLAttributes, MouseEvent } from 'react';

type PageLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  navigate: (href: string) => void;
};
export function PageLink({ href, navigate, onClick, children, ...props }: PageLinkProps) {
  function follow(event: MouseEvent<HTMLAnchorElement>) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      props.target === '_blank'
    )
      return;
    onClick?.(event);
    if (event.defaultPrevented) return;
    event.preventDefault();
    navigate(href);
  }
  return (
    <a {...props} href={href} onClick={follow}>
      {children}
    </a>
  );
}
